import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import StatusTable from './StatusTable';
import UserPermissions from "../model/userPermissions";

const StatusTab: FC<{ permissions: UserPermissions, accessToken: string }> = ({ permissions, accessToken }) => {
  const { t } = useTranslation();

  return (
    <div className="status-tab">
      <h1 className="tab-heading">{t('status.tab.title')}</h1>
      <StatusTable permissions={permissions} accessToken={accessToken} />
    </div>
  );
};

export default StatusTab;
